import { JWPlayerVideos } from "@advice/apps/initJWPlayerVideos";
import { initHeader } from "@advice/apps/initHeader";
import { initEmailCapture } from "@advice/apps/initEmailCapture";
import { initJobsSidebar } from "@advice/apps/initJobsSidebar";
import { initLazyImages } from "@advice/apps/initLazyImages";
import { initOskarTriggers } from "@advice/apps/initOskarTriggers";
import { IInitialState } from "@server/util/pageWrapper";
import { ExperimentAB, IExperimentAB } from "@util/experiment";
import { initGrowform } from "./apps/initGrowform";
import { initExperiment } from "./apps/initExperiment";

export interface AdviceWindow extends Window {
    __MUSE__: {
        initialState: IInitialState;
    };
    dataLayer: IMetadataObj[];
    experiment: IExperimentAB;
    ga: UniversalAnalytics.ga;
}

declare const window: AdviceWindow;

document.addEventListener("DOMContentLoaded", async () => {
    const initialState = window.__MUSE__.initialState;
    initLazyImages();
    window.experiment = new ExperimentAB(initialState?.config?.experiments);
    const excludedPages = [
        "185-powerful-verbs-that-will-make-your-resume-awesome",
        "51-interview-questions-you-should-be-asking",
        "7-goodbye-email-templates-youll-need-when-you-quit-your-job",
        "how-to-gracefully-turn-down-a-job-offer",
        "how-to-write-a-resignation-letter",
        "how-to-write-an-interview-thankyou-note-an-email-template",
        "interview-questions-and-answers",
        "star-interview-method",
        "team-building-activities-games-for-work-office",
        "tell-me-about-yourself-interview-question-answer-examples",
        "test-listicle-5-21-2020", // This is to test on staging and local
    ];
    const excludeExperiment = excludedPages.includes(initialState.slug);

    if (!excludeExperiment) {
        await initExperiment();
    }
    await initHeader(initialState);
    await initJobsSidebar();
    if (window.experiment.isAssignedExperiment("JOB_QUIZ_FORM") &&
        window.dataLayer[0].cms_post_type !== "landing" &&
        !window.dataLayer[0].is_sponsored &&
        !excludeExperiment &&
        window.experiment.currentVariant.name !== "control"
    ) {
        await initGrowform();
    }
    await initOskarTriggers();
    await initEmailCapture(initialState);
    const jwPlayerID = ((initialState || {}).config || {}).jwPlayerID;
    if (jwPlayerID) {
        try {
            JWPlayerVideos.initJWPlayerVideos(jwPlayerID, initialState?.config);
        } catch (error) {
            console.error("Could not initialize JWPlayer Videos: ", error);
        }
    }
});
